// extracted by mini-css-extract-plugin
export default {"wrapper":"a6wsqW","external":"b6wsqW","topText":"c6wsqW"};